/* Sarebbe bello che l'icona del problema del giorno si aggiornasse 
				quando uno risolve il problema 
	Vorrei fare una riga di separazione bella nella home tipo quella di default di navigazione
	Mettere livelli con xp - trofei o missioni tipo chess.com (tot problemi di certa difficoltà risolti) */
import {
	View,
	Text,
	Image,
	SafeAreaView,
	TouchableOpacity,
	ScrollView,
	Button,
} from "react-native";
import { useLayoutEffect, useEffect, useState, useContext } from "react";
import { useNavigation } from "@react-navigation/native";
import { AvatarImage, PinguinoNormaleImage } from "../assets";
import HomeCard from "../components/HomeCard";
import { DrawerActions } from "@react-navigation/native";
import { AntDesign } from "@expo/vector-icons";

import {
	getAuth,
	getIdToken,
	GoogleAuthProvider,
	onAuthStateChanged,
	signInWithCredential,
	signOut,
} from "firebase/auth";
import { sessionData, app, getUserFullName } from "../utils/firebase";

const HomeScreen = () => {
	const navigation = useNavigation();
	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitleAlign: "center",
			headerStyle: {
				backgroundColor: "#263238",
			},
			headerTitleStyle: {
				color: "white",
			},
			headerTintColor: "white",
			headerShadowVisible: false,
		});
	}, []);

	// const { loginState, setLoginState } = useContext(AuthContext);

	return (
		<SafeAreaView className=" bg-[#263238] flex-1 space-y-4">
			<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
				<ScrollView className="flex-1">
					{/* Barra in alto */}
					{/* <View className="flex-row items-center justify-between px-4 border-b border-[#1E272C]">
				<TouchableOpacity
					className=""
					onPress={() => {
						navigation.dispatch(DrawerActions.toggleDrawer());
					}}
				>
					<AntDesign name="menuunfold" size={26} color="white" />
				</TouchableOpacity>
				<View className="items-center justify-center">
					<Text className="text-xl semibold text-white">
						Nome Applicazione
					</Text>
				</View>
				<TouchableOpacity
					className="mt-1 mb-1"
					onPress={() => promptAsync()}
				>
					<Image
						source={AvatarImage}
						className="w-10 h-10 rounded-full"
					/>
				</TouchableOpacity>
			</View> */}

					{/* Benvenuto + Pinguino */}
					<View className="flex-row items-center justify-between px-4 mt-2">
						<View className="flex-column w-1/2">
							<Text className="text-xl font-bold text-white">
								Felice di vederti
							</Text>
							<Text className="text-2xl text-white">
								{getUserFullName()}
							</Text>
						</View>
						<Image
							source={PinguinoNormaleImage}
							// className="w-[90px] h-[85px]"
							className="w-[150px] h-[150px]"
						/>
					</View>

					{/* Sezione con tutte le scelte */}
					<HomeCard
						title="Problema consigliato"
						name_icon="puzzle"
						destination="SuggestedProblem"
						color="#f78c6c"
						description="Lascia che pensiamo noi a trovare il problema giusto per te!"
					/>
					<HomeCard
						title="Problema del giorno"
						name_icon="calendar-clock"
						destination="ProblemOfTheDay"
						color="#009688"
						description="Risolvi il problema di cui tutti parlano!"
					/>
					<HomeCard
						title="Ricerca problema"
						name_icon="database-search-outline"
						destination="ProblemSearch"
						color="#89ddff"
						description="Cerca il problema che più ti interessa!"
					/>
					<HomeCard
						title="YouTube - mateMATTIci"
						name_icon="youtube"
						destination="MateMATTIci"
						color="#ff5370"
						description="Seguici su YouTube!"
					/>
				</ScrollView>
			</View>
		</SafeAreaView>
	);
};

export default HomeScreen;
